import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import Image from 'next/image';
import logo from '@/assets/images/logo-red.png';

type LoadingModalProps = {
  isOpen: boolean;
  title?: string;
  message?: string;
};

export default function LoadingModal({
  isOpen,
  title,
  message,
}: LoadingModalProps) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-90"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-90"
          >
            <Dialog.Panel className="bg-white rounded-2xl p-8 w-[90%] max-w-xl sm:w-full shadow-xl flex flex-col items-center justify-center gap-10">
              <p className="text-xl sm:text-3xl font-semibold text-black mt-20">
                {title}
              </p>

              <div className="relative w-40 h-40">
                <div className="absolute inset-0 rounded-full border-4 border-b-crunchies-red border-t-transparent animate-spin"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <Image
                    src={logo}
                    alt="Crunchies Logo"
                    width={40}
                    height={40}
                    className="object-contain"
                  />
                </div>
              </div>

              <p className="text-xl text-crunchies-red font-medium">{message}</p>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
